import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from 'axios';

const authContext = createContext();

const openTwitchAuth = () => {
    const w = 505;
    const h = 860;
    const y = window.top.outerHeight / 2 + window.top.screenY - (h / 2);
    const x = window.top.outerWidth / 2 + window.top.screenX - (w / 2);

    const win = window.open(
        `https://twitchingofisaac.com/auth/login`,
        'AuthWindow',
        `toolbar=no,location=no,directories=no,status=no,menubar=no,resizable=np,copyhistory=no,width=${w},height=${h},top=${y},left=${x}`
    );

    const timer = setInterval(() => {
        if (win.closed) {
            clearInterval(timer);
        }
    }, 500);
}

export const useAuth = () => {
    return useContext(authContext);
}

const useProvideAuth = () => {
    const [authenticated, setAuthenticated] = useState(false);
    const [user, setUser] = useState({});

    const logout = useCallback(() => {
        setUser({});
        setAuthenticated(false);
        axios('/auth/logout');
    }, []);

    const login = useCallback(() => {
        return new Promise((resolve, reject) => {
            openTwitchAuth();

            const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            const removeMethod = window.removeEventListener ? "removeEventListener" : "detachEvent";
            const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

            window[eventMethod](messageEvent, (ev) => {
                if (
                    ev.origin === `https://${window.location.hostname}` ||
                    ev.origin === `https://twitchingofisaac.com`
                ) {
                    if ('login' in ev.data && ev.data['login'] === 'ok') {
                        setUser(ev.data['user']);
                        setAuthenticated(true);
                        return resolve();
                    }
                } else {
                    console.log('Access violation');
                    return reject("Access violation.")
                }
                window[removeMethod](messageEvent, this);
                reject("Unknown response.");
            });
        });
    }, []);

    const getLoggedInUser = async () => {
        try {
            const { data } = await axios(
                '/api/me',
            );

            if (data.status === 200) {
                setUser(data.response);
                setAuthenticated(true);
            }
        } catch (err) {
            console.log(err)
        }
    }


    return {
        authenticated,
        login,
        logout,
        user,
        getLoggedInUser,
    };
}

export const AuthProvider = ({ children }) => {
    const auth = useProvideAuth();

    useEffect(() => {
        auth.getLoggedInUser();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <authContext.Provider value={auth}>
            {children}
        </authContext.Provider>
    );
}

/*
import React, { useEffect } from 'react';
import axios from 'axios';

const AuthContext = React.createContext({
    authenticated: false,
    user: {},
    login: () => {},
    logout: () => {}
});

export function useAuth() {
    return React.useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [authenticated, setAuthenticated] = React.useState(false);
    const [user, setUser] = React.useState({});

    useEffect(() => {
        async function getLoggedInUser() {
            try {
                const { data } = await axios(
                    '/api/me',
                );

                if (data.status === 200) {
                    console.log(data.response)
                    setUser(data.response);
                    setAuthenticated(true);
                }
            } catch (err) {
                console.log(err)
            }
        }
        getLoggedInUser();
    }, [])

    const contextValue = {
        authenticated,
        user,
        login() {
            alert("login accessed?")
            return new Promise((resolve, reject) => {
                openTwitchAuth();

                const eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                const removeMethod = window.removeEventListener ? "removeEventListener" : "detachEvent";
                const messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";

                window[eventMethod](messageEvent, (ev) => {
                    if (
                        ev.origin === `https://${window.location.hostname}` ||
                        ev.origin === `https://twitchingofisaac.com`
                    ) {
                        if ('login' in ev.data && ev.data['login'] === 'ok') {
                            setUser(ev.data['user']);
                            setAuthenticated(true);
                            return resolve();
                        }
                    } else {
                        console.log('Access violation');
                        return reject("Access violation.")
                    }
                    window[removeMethod](messageEvent, this);
                    reject("Unknown response.")
                });
            });
        },
        logout() {
            return new Promise((res) => {
                setUser({})
                setAuthenticated(false);
                res();
            });
        }
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    )
}


*/